<ng-container
  *appLet="{
    doesPnrExist: doesPnrExist$ | async,
    isFlightsPage: isFlightsPage$ | async,
    isHomePage: isHomePage$ | async,
    isModifyPath: isModifyPath$ | async,
    stations: stations$ | async,
    stationsWithConnections: stationsWithConnections$ | async,
    norseStations: norseStations$ | async,
    dohopStations: dohopStations$ | async,
    culture: culture$ | async,
    lastSearchedCriteria: lastSearchedCriteria$ | async,
    selectedCurrencyCode: selectedCurrencyCode$ | async,
    geolocatedCountryCode: geolocatedCountryCode$ | async,
    isModifyWidget: isModifyWidget$ | async,
    passengers: passengers$ | async,
    featStringValueUS1416US: gbs.growthBook.getFeatureValue('feat-001416-change-search-area-to-media-content-US', ''),
    featStringValueUS1416ROW: gbs.growthBook.getFeatureValue('feat-001416-change-search-area-to-media-content-ROW', ''),
    featStringValueUS1611: gbs.growthBook.getFeatureValue('feat-001611-commercial-bubble-frontpage', ''),
  } as $comp"
>
    @if (searchWidgetForm) {
        <div class="container">
            <form
                [formGroup]="searchWidgetForm"
                class="search-container"
                [class.search-container--background]="background"
                [class.py-3]="!background"
                (ngSubmit)="onSubmit(
                    $comp.selectedCurrencyCode,
                    $comp.culture ?? FALLBACK_CULTURE,
                    $comp.lastSearchedCriteria ?? undefined,
                    $comp.geolocatedCountryCode ?? undefined,
                    undefined,
                    $comp.isModifyPath ?? false
                )">
                @if ($comp.isHomePage && $comp.featStringValueUS1611 === 'b' && ($comp.featStringValueUS1416US !== 'a' || $comp.featStringValueUS1416ROW !== 'a') && !!appCopy && !!appCopy.searchWidgetFull) {
                    <div class="search-bubble">
                        <div class="search-bubble__title">{{ appCopy.searchWidgetFull.searchBubbleTitle }}</div>
                        <p class="search-bubble__copy">{{ appCopy.searchWidgetFull.searchBubbleCopy }}<a
                            [routerLink]="['/experience', 'where-we-fly']">{{ appCopy.searchWidgetFull.searchBubbleLink }}</a>
                            {{ appCopy.searchWidgetFull.searchBubbleCopy2 }}
                        </p>
                    </div>
                }
                <app-search-header
                    [cmsCopy]="appCopy[CmsSubKeys.searchWidgetFull]">
                </app-search-header>

                <div class="search-form"
                    *appLet="
                        ($comp.isFlightsPage ?? false) &&
                        ($comp.doesPnrExist ?? false) as isStationPickerDisabled">
                    <div class="search-form__header">
                        <app-trip-type-picker
                            [formGroup]="tripTypePromoCntl"
                            [cmsSearchWidgetCopy]="cmsCopy">
                        </app-trip-type-picker>
                        <div class="placeholder-float-left center-label float-label-white"
                            [ngClass]="{'visually-hidden': !searchService.showPromoInput(cmsCopy.promoInputShow)}">
                            <app-input
                                [formGroup]="tripTypePromoCntl"
                                [label]="cmsCopy.promoCode">
                                <input
                                    appInput
                                    type="text"
                                    name="promoCode"
                                    data-qa="promoCode"
                                    formControlName="promoCode"
                                    class="form-control promo-input"
                                    maxlength="8"
                                    [placeholder]="cmsCopy.promoCode"/>
                            </app-input>
                        </div>
                    </div>
                    @for (item of stationsCtrl.controls; track $index) {
                        <div class="search-form__controls">
                            <div class="search-form__stations">
                                <app-station-picker
                                    [isDisabled]="isStationPickerDisabled"
                                    [formGroup]="getStationsCtrl($index)"
                                    [index]="$index"
                                    [stations]="activeStations"
                                    [culture]="$comp.culture ?? FALLBACK_CULTURE"
                                    [tripType]="tripTypeCntl.value"
                                    [norseStations]="$comp.norseStations"
                                    [dohopFeatureStations]="$comp.dohopStations"
                                    (originStationChange)="onOriginStationChange($event, $index)"
                                    (destinationStationChange)="
                                    onDestinationStationChange($event, $index)
                                    "
                                    (keydown.enter)="$event.preventDefault()"
                                    [copy]="cmsCopy"
                                    [stationsForceMacCode]="cmsCopy.stationsForceMacCode"
                                    [isDateRangePickerEnabled]="searchService.isDateRangePickerEnabled">
                                </app-station-picker>
                                @if (
                                    $comp.isHomePage &&
                                    isValidStationCtrl($index) &&
                                    searchService.isDateRangePickerEnabled
                                ) {
                                    <app-date-range-picker
                                        [desktopFirstDatePlaceholder]="cmsCopy.departDate"
                                        [desktopSecondDatePlaceholder]="cmsCopy.returnDate"
                                        [mobileConfirmButtonText]="appCopy.confirm"
                                        [mobileDatePlaceholder]="appCopy.whereAreYouFlying"
                                        [mobileHeaderTitle]="appCopy.whereAreYouFlying"
                                        [mobileSkipButtonText]="appCopy.imFlexible"
                                        [skipText]="appCopy.imFlexible"
                                        [noSkipText]="appCopy.exactDates"
                                        [withSkip]="true"
                                        [isSingleDate]="isDatePickerSingleDate"
                                        [disabledFirstDateRange]="getDisabledDatesForDepartDate($index)"
                                        [disabledSecondDateRange]="getDisabledDatesForReturnDate($index)"
                                        [startDate]="getFirstDateForDateRangePicker($index)"
                                        [endDate]="getLastDateForDateRangePicker($index)"
                                        (dateChanges)="onDateRangePickerChanges($index, $event)">
                                    </app-date-range-picker>
                                }
                                <div class="dates-picker-container visually-hidden">
                                    <app-dates-picker
                                        [formGroup]="getDatesCtrl($index)"
                                        [tripType]="tripTypeCntl.value"
                                        [minDate]="minDates[$index] ?? DEFAULT_MIN_DATE"
                                        [maxDate]="scheduleLoadedThruDateAsDate ?? DEFAULT_MAX_DATE"
                                        [departDates]="departDates[$index]"
                                        [returnDates]="returnDates"
                                        [departDateClasses]="departDateClasses[$index]"
                                        [returnDateClasses]="returnDateClasses"
                                        [group]="$index"
                                        [cmsEntries]="{
                                        departDate: cmsCopy.departDate,
                                        returnDate: cmsCopy.returnDate
                                        }"
                                        (departDateChange)="onDepartDateChange($index)"
                                    ></app-dates-picker>
                                </div>
                            </div>
                            @if (isFlightsPage) {
                                <app-traveler-picker
                                    formGroupName="travelers"
                                    [isDisabled]="isStationPickerDisabled"
                                    [cmsSearchWidgetCopy]="cmsCopy">
                                </app-traveler-picker>
                            }
                        </div>
                    }
                </div>
                <app-search-footer
                    [cmsCopy]="appCopy[CmsSubKeys.searchWidgetFull]"
                    [isFlightsPage]="$comp.isFlightsPage"
                    (cancelClick)="searchService.onCancelModifySearch()">
                </app-search-footer>
                <app-previous-search
                    [stations]="stations"
                    (lastSearchClicked)="lastSearchClicked = $event">
                </app-previous-search>
            </form>
        </div>
    }
</ng-container>